import "../assets/css/CommonBanner.css"
import { Link } from "react-router-dom"
const CommonBanner = ({title, image, breadcrumb, color}) => {
  return (
    <section className="contactBanner" style={{backgroundImage: `url(${image})`}}>
        <div className="contact_container">
          <h1 style={{color:color}}>{title}</h1>
          <div className="breadcrumbBox" >
          {breadcrumb.map((item, index) => (
            <span key={index}>
              {index === breadcrumb.length - 1 ? (
                <span className="activeBreadcrumb">{item.page}</span>
              ) : (
                <>
                  <Link to={item.url} style={{color:color}}>{item.page}</Link>
                  <span className="breadcrumbSeparator" style={{color:color}}> / </span>
                </>
              )}
            </span>
          ))}
        </div>

        </div>
      </section>
  )
}

export default CommonBanner
